import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import taskimage from '../../../../assets/img/taskimg.png';
import { AiFillStar, AiOutlineCheckCircle } from 'react-icons/ai';
import { TbAsteriskSimple } from 'react-icons/tb';
import whyjoin from '../../../../assets/img/why-join.png';
import protection from '../../../../assets/img/protection.png';
import { MdSecurity, MdOutlinePrivacyTip } from 'react-icons/md';
import { AiOutlineStar } from 'react-icons/ai';

const DigitalMarketingBuyer = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Digital Marketing </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Digital Marketing</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='audio-video-buyer'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='audio-video-buyer-title'>
                                <h3>Audio Video Editing tasks</h3>
                                <p>Check out what tasks people want done near you right now...</p>
                            </div>
                            <div className='audio-video-buyer-tasks'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='audio-video-buyer-flex'>
                                                    <div className='audio-video-buyer-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                    </div>
                                                    <div className='audio-video-title'>
                                                        <Card.Title>Adam</Card.Title>
                                                        <p className='title-wrap'>St James</p>
                                                        <div className='d-flex'>
                                                            <div className="rating" >
                                                                <input id="rating-5" type="radio" name="rating" value="5" /><label htmlFor="rating-5"><AiFillStar /></label>
                                                                <input id="rating-4" type="radio" name="rating" value="4" defaultChecked /><label htmlFor="rating-4"><AiFillStar /></label>
                                                                <input id="rating-3" type="radio" name="rating" value="3" /><label htmlFor="rating-3"><AiFillStar /></label>
                                                                <input id="rating-2" type="radio" name="rating" value="2" /><label htmlFor="rating-2"><AiFillStar /></label>
                                                                <input id="rating-1" type="radio" name="rating" value="1" /><label htmlFor="rating-1"><AiFillStar /></label>
                                                            </div>
                                                            <div>(1625)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='audio-video-desc'>
                                                    <p className='latest-review'>Latest Reviews</p>
                                                    <p className='review'>"Friendly, helpful and did the job right "</p>
                                                </div>
                                                <div className='request-quote'>
                                                    <Link className="request-quote-btn" to="/">Request Quote</Link>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='audio-video-buyer-flex'>
                                                    <div className='audio-video-buyer-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                    </div>
                                                    <div className='audio-video-title'>
                                                        <Card.Title>Adam</Card.Title>
                                                        <p className='title-wrap'>St James</p>
                                                        <div className='d-flex'>
                                                            <div className="rating" >
                                                                <input id="rating-5" type="radio" name="rating" value="5" /><label htmlFor="rating-5"><AiFillStar /></label>
                                                                <input id="rating-4" type="radio" name="rating" value="4" defaultChecked /><label htmlFor="rating-4"><AiFillStar /></label>
                                                                <input id="rating-3" type="radio" name="rating" value="3" /><label htmlFor="rating-3"><AiFillStar /></label>
                                                                <input id="rating-2" type="radio" name="rating" value="2" /><label htmlFor="rating-2"><AiFillStar /></label>
                                                                <input id="rating-1" type="radio" name="rating" value="1" /><label htmlFor="rating-1"><AiFillStar /></label>

                                                            </div>
                                                            <div>(1625)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='audio-video-desc'>
                                                    <p className='latest-review'>Latest Reviews</p>
                                                    <p className='review'>"Friendly, helpful and did the job right "</p>
                                                </div>
                                                <div className='request-quote'>
                                                    <Link className="request-quote-btn" to="/">Request Quote</Link>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='audio-video-buyer-flex'>
                                                    <div className='audio-video-buyer-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                    </div>
                                                    <div className='audio-video-title'>
                                                        <Card.Title>Adam</Card.Title>
                                                        <p className='title-wrap'>St James</p>
                                                        <div className='d-flex'>
                                                            <div className="rating" >
                                                                <input id="rating-5" type="radio" name="rating" value="5" /><label htmlFor="rating-5"><AiFillStar /></label>
                                                                <input id="rating-4" type="radio" name="rating" value="4" defaultChecked /><label htmlFor="rating-4"><AiFillStar /></label>
                                                                <input id="rating-3" type="radio" name="rating" value="3" /><label htmlFor="rating-3"><AiFillStar /></label>
                                                                <input id="rating-2" type="radio" name="rating" value="2" /><label htmlFor="rating-2"><AiFillStar /></label>
                                                                <input id="rating-1" type="radio" name="rating" value="1" /><label htmlFor="rating-1"><AiFillStar /></label>

                                                            </div>
                                                            <div>(1625)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='audio-video-desc'>
                                                    <p className='latest-review'>Latest Reviews</p>
                                                    <p className='review'>"Friendly, helpful and did the job right "</p>
                                                </div>
                                                <div className='request-quote'>
                                                    <Link className="request-quote-btn" to="/">Request Quote</Link>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='audio-video-buyer-flex'>
                                                    <div className='audio-video-buyer-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                    </div>
                                                    <div className='audio-video-title'>
                                                        <Card.Title>Adam</Card.Title>
                                                        <p className='title-wrap'>St James</p>
                                                        <div className='d-flex'>
                                                            <div className="rating" >
                                                                <input id="rating-5" type="radio" name="rating" value="5" /><label htmlFor="rating-5"><AiFillStar /></label>
                                                                <input id="rating-4" type="radio" name="rating" value="4" defaultChecked /><label htmlFor="rating-4"><AiFillStar /></label>
                                                                <input id="rating-3" type="radio" name="rating" value="3" /><label htmlFor="rating-3"><AiFillStar /></label>
                                                                <input id="rating-2" type="radio" name="rating" value="2" /><label htmlFor="rating-2"><AiFillStar /></label>
                                                                <input id="rating-1" type="radio" name="rating" value="1" /><label htmlFor="rating-1"><AiFillStar /></label>

                                                            </div>
                                                            <div>(1625)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='audio-video-desc'>
                                                    <p className='latest-review'>Latest Reviews</p>
                                                    <p className='review'>"Friendly, helpful and did the job right "</p>
                                                </div>
                                                <div className='request-quote'>
                                                    <Link className="request-quote-btn" to="/">Request Quote</Link>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='audio-video-buyer-flex'>
                                                    <div className='audio-video-buyer-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                    </div>
                                                    <div className='audio-video-title'>
                                                        <Card.Title>Adam</Card.Title>
                                                        <p className='title-wrap'>St James</p>
                                                        <div className='d-flex'>
                                                            <div className="rating" >
                                                                <input id="rating-5" type="radio" name="rating" value="5" /><label htmlFor="rating-5"><AiFillStar /></label>
                                                                <input id="rating-4" type="radio" name="rating" value="4" defaultChecked /><label htmlFor="rating-4"><AiFillStar /></label>
                                                                <input id="rating-3" type="radio" name="rating" value="3" /><label htmlFor="rating-3"><AiFillStar /></label>
                                                                <input id="rating-2" type="radio" name="rating" value="2" /><label htmlFor="rating-2"><AiFillStar /></label>
                                                                <input id="rating-1" type="radio" name="rating" value="1" /><label htmlFor="rating-1"><AiFillStar /></label>

                                                            </div>
                                                            <div>(1625)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='audio-video-desc'>
                                                    <p className='latest-review'>Latest Reviews</p>
                                                    <p className='review'>"Friendly, helpful and did the job right "</p>
                                                </div>
                                                <div className='request-quote'>
                                                    <Link className="request-quote-btn" to="/">Request Quote</Link>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='audio-video-buyer-flex'>
                                                    <div className='audio-video-buyer-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                    </div>
                                                    <div className='audio-video-title'>
                                                        <Card.Title>Adam</Card.Title>
                                                        <p className='title-wrap'>St James</p>
                                                        <div className='d-flex'>
                                                            <div className="rating" >
                                                                <input id="rating-5" type="radio" name="rating" value="5" /><label htmlFor="rating-5"><AiFillStar /></label>
                                                                <input id="rating-4" type="radio" name="rating" value="4" defaultChecked /><label htmlFor="rating-4"><AiFillStar /></label>
                                                                <input id="rating-3" type="radio" name="rating" value="3" /><label htmlFor="rating-3"><AiFillStar /></label>
                                                                <input id="rating-2" type="radio" name="rating" value="2" /><label htmlFor="rating-2"><AiFillStar /></label>
                                                                <input id="rating-1" type="radio" name="rating" value="1" /><label htmlFor="rating-1"><AiFillStar /></label>

                                                            </div>
                                                            <div>(1625)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='audio-video-desc'>
                                                    <p className='latest-review'>Latest Reviews</p>
                                                    <p className='review'>"Friendly, helpful and did the job right "</p>
                                                </div>
                                                <div className='request-quote'>
                                                    <Link className="request-quote-btn" to="/">Request Quote</Link>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='why-join'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                            <div className='why-join-title'>
                                <h3>Why join Taskde?</h3>
                                <p>Here are few great reasons</p>
                            </div>
                            <div className='why-join-desc'>
                                <div className='why-join-desc-input'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill='#264796'><path d="M20,3.59H16.75V2.66a.75.75,0,1,0-1.5,0v.93H8.75V2.66a.75.75,0,1,0-1.5,0v.93H4A2.75,2.75,0,0,0,1.25,6.34v13A2.75,2.75,0,0,0,4,22.09H20a2.75,2.75,0,0,0,2.75-2.75v-13A2.75,2.75,0,0,0,20,3.59ZM4,5.09H7.25V6.16a.75.75,0,0,0,1.5,0V5.09h6.5V6.16a.75.75,0,0,0,1.5,0V5.09H20a1.25,1.25,0,0,1,1.25,1.25V8.59H2.75V6.34A1.25,1.25,0,0,1,4,5.09ZM21.25,19.34A1.25,1.25,0,0,1,20,20.59H4a1.25,1.25,0,0,1-1.25-1.25V10.09h18.5Z"></path><path d="M8,16.84a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,8,16.84Zm0-3.5a1,1,0,1,1-1,1A1,1,0,0,1,8,13.34Z"></path></svg>
                                    <h3 className='ms-2'>Flexibility</h3>
                                </div>
                                <p>Choose the tasks that you want to complete for the people that you’re comfortable working with. You’re in control of your own schedule to create the work-life balance that works for you.</p>
                                <div className='why-join-desc-input'>
                                    <MdSecurity fill='#264796' style={{ width: '24px', height: '24px' }} />
                                    <h3 className='ms-2'>Fast and secure payments</h3>
                                </div>
                                <p>We secure payment for you even before you start the task so you can be sure the payment is there when the task is complete.</p>
                                <div className='why-join-desc-input'>
                                    <TbAsteriskSimple fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                    <h3 className='ms-2'>Simple to use</h3>
                                </div>
                                <p>You can start browsing jobs near you immediately. You can filter by location and skills and be notified when tasks you’re interested in pop up near you.</p>

                            </div>
                            <div className='why-join-btn'>
                                <Link className="becometasker scrollto" to="/signup">Join Taskde</Link>
                            </div>
                        </div>
                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                            <div className='why-join-img'>
                                <img src={whyjoin} className='img-fluid' alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='razorpay'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>

                            <div className='razorpay-wrapper'>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='razorpay-main'>
                                                    <div className='razorpay-subtitle'>
                                                        <h5>Razorpay</h5>
                                                        <p>Now available!</p>
                                                    </div>
                                                    <div className='razorpay-text'>
                                                        <ul>
                                                            <li><AiOutlineCheckCircle size={22} style={{ color: "#fff" }} /> Get it done now. Pay later.</li>
                                                            <li><AiOutlineCheckCircle size={22} style={{ color: "#fff" }} /> Repay in 4 fortnightly instalments</li>
                                                        </ul>
                                                    </div>
                                                    <div className='razorpay-text'>
                                                        <ul>
                                                            <li><AiOutlineCheckCircle size={22} style={{ color: "#fff" }} /> Get it done now. Pay later.</li>
                                                            <li><AiOutlineCheckCircle size={22} style={{ color: "#fff" }} /> Repay in 4 fortnightly instalments</li>
                                                        </ul>
                                                    </div>
                                                    <div className='razorpay-link'>
                                                        <a className='' href='https://razorpay.com/' target="_blank" rel="noopener noreferrer">Learn more</a>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className='counter'>
                <div className='container'>
                    <div className='counter-wrap'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                                <Card>
                                    <Card.Body>
                                        <h5 className='counter-title'>3000</h5>
                                        <p className='counter-desc'>Task successfully completed</p>

                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                                <Card>
                                    <Card.Body>

                                        <h5 className='counter-title'>2</h5>
                                        <p className='counter-desc'>Avg. quote per task</p>

                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                                <Card>
                                    <Card.Body>
                                        <h5 className='counter-title'>6<span className='counter-span'>hrs</span></h5>
                                        <p className='counter-desc'>Avg. time to recieve offer</p>

                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='protection'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                            <div className='protection-img'>
                                <img src={protection} className='img-fluid' alt='' />
                            </div>
                        </div>
                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                            <div className='protection-title'>
                                <h3>Protection</h3>
                                <p>It’s nice to have a safety net - that’s why we’ve got insurance available to help you do tasks with peace of mind.</p>
                            </div>
                            <div className='protection-desc'>
                                <div className='protection-desc-input'>
                                    <MdOutlinePrivacyTip fill='#264796' style={{ width: '24px', height: '24px' }} />
                                    <h3 className='ms-2'>Public Liability*</h3>
                                </div>
                                <p>Taskde Insurance covers the Tasker for their liability to third parties for personal injury or property damage whilst performing certain task activities</p>
                                <div className='protection-desc-input'>
                                    <AiOutlineStar fill='#264796' style={{ width: '24px', height: '24px' }} />
                                    <h3 className='ms-2'>Top rated insurance</h3>
                                </div>
                                <p>Taskde Insurance is provided by Berkshire Hathaway Specialty Insurance - one of the most reputable and innovative insurance brands</p>
                                <div className='protection-terms'>
                                    <p>*subject to terms and conditions, excess and exclusions applies.</p>
                                </div>
                            </div>
                            <div className='protection-btn'>
                                <Link className="becometasker scrollto" to="/">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section id="faq" className="faq">
                <div className="container-fluid" >

                    <div className="row gy-4">

                        <div className="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

                            <div className="content px-xl-5 mb-5">
                                <h3>Top Delivery related questions</h3>
                            </div>

                            <div className="accordion accordion-flush px-xl-5" id="faqlist">
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className="accordion-item" >
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-1">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Non consectetur a erat nam at lectus urna duis?
                                                </button>
                                            </h3>
                                            <div id="faq-content-1" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                <div className="accordion-body">
                                                    Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className="accordion-item" >
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-2">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Non consectetur a erat nam at lectus urna duis?
                                                </button>
                                            </h3>
                                            <div id="faq-content-2" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                <div className="accordion-body">
                                                    Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className="accordion-item" >
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-3">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Feugiat scelerisque varius morbi enim nunc faucibus a pellentesque?
                                                </button>
                                            </h3>
                                            <div id="faq-content-3" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                <div className="accordion-body">
                                                    Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='col-lg-6'>
                                        <div className="accordion-item" >
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-4">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi?
                                                </button>
                                            </h3>
                                            <div id="faq-content-4" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                <div className="accordion-body">
                                                    Eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis orci. Faucibus pulvinar elementum integer enim. Sem nulla pharetra diam sit amet nisl suscipit. Rutrum tellus pellentesque eu tincidunt. Lectus urna duis convallis convallis tellus. Urna molestie at elementum eu facilisis sed odio morbi quis
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className="accordion-item" >
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-5">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Ac odio tempor orci dapibus. Aliquam eleifend mi in nulla?
                                                </button>
                                            </h3>
                                            <div id="faq-content-5" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                <div className="accordion-body">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-6'>
                                        <div className="accordion-item" >
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-6">
                                                    <i className="bi bi-question-circle question-icon"></i>
                                                    Tempus quam pellentesque nec nam aliquam sem et tortor consequat?
                                                </button>
                                            </h3>
                                            <div id="faq-content-6" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                <div className="accordion-body">
                                                    Molestie a iaculis at erat pellentesque adipiscing commodo. Dignissim suspendisse in est ante in. Nunc vel risus commodo viverra maecenas accumsan. Sit amet nisl suscipit adipiscing bibendum est. Purus gravida quis blandit turpis cursus in
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>


                    </div>

                </div>
            </section> */}
            <Footer />
        </React.Fragment >
    )
}

export default DigitalMarketingBuyer;